import { combineReducers } from "redux";
import color from "redux/slices/color";
import menu from "redux/slices/menu";
import user from "redux/slices/user";

const rootReducer = combineReducers({ user, menu, color });

export default rootReducer;
